import {inputAnatomy} from '@chakra-ui/anatomy';
import {createMultiStyleConfigHelpers} from '@chakra-ui/react';
import {colorByMode} from 'theme/themeHelper';
const {definePartsStyle, defineMultiStyleConfig} =
    createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
    // define the part you're going to style
    field: {
        fontFamily: 'mono', // change the font family
        color: 'teal.500', // change the input text color
        height: 29
    },
});
const Input = defineMultiStyleConfig({
	// The styles all button have in common
	baseStyle: {
	},
	height: 29,
	sizes: {
		sm: {
			height: 29,
			py: 10,
		},
		md: {
			py: 10,
		},
	},
	variants: {
		outline: (props) => {
			return {
				field: {
					borderColor: colorByMode("border", props.colorMode),
					rounded: "base",
					fontSize: "xs",
					_hover: {
						borderColor: "gray.400",
					},
					_dark: {
						borderColor: colorByMode("border", props.colorMode),
						_hover: {
							borderColor: "gray.300",
						},
						_focus: {
							boxShadow: `0 0 0 1px ${colorByMode(
								"primary",
								props.colorMode
							)}`,
							borderColor: colorByMode(
								"primary",
								props.colorMode
							),
						},
					},
					_focus: {
						boxShadow: `0 0 0 1px ${colorByMode(
							"primary",
							props.colorMode
						)}`,
						borderColor: colorByMode("primary", props.colorMode),
					},
                    _focusVisible: {
						borderColor: colorByMode("primary", props.colorMode),
                    }
				},
			};
		},
		filled: (props) => {
			return {
				field: {
					rounded: "base",
					backgroundColor:
						props.colorMode === "light" ? "gray.100" : "bg.800",
					fontSize: "xs",
					_hover: {
						backgroundColor:
							props.colorMode === "light" ? "gray.200" : "bg.700",
					},
					_focus: {
						backgroundColor: colorByMode(
							"brighterBg",
							props.colorMode
						),
						// boxShadow: `0 0 0 1px ${colorByMode(
						// 	"primary",
						// 	props.colorMode
						// )}`,
					},
					_focusVisible: {
						borderColor: colorByMode("primary", props.colorMode),
					},
				},
			};
		},
	},
	// // The default size and variant values
	defaultProps: {
		size: "sm",
		height: 29,
	},
});

export default Input;
